export const CREATE_PROJECT = {
  DELETE_MODAL_TITLE: 'deleteProjectModalTitle',
  DELETE_MODAL_DESCRIPTION: 'deleteProjectModalDescription',
  DELETE_MODAL_CANCEL_BUTTON: 'deleteProjectModalCancelButton',
  DELETE_MODAL_DELETE_BUTTON: 'deleteProjectModalDeleteButton',
  PRIMARY_BUTTON_DEFAULT: 'nextButton',
  PROJECT_FIELD_SCHEDULE_MODAL: 'projectFieldScheduleModal',
  PROJECT_COLORS_SECTION: 'projectThumbnailColorCircles',
  PROJECT_THUMBNAIL_PREVIEW: 'projectThumbnailPreview',
  CREATE_PROJECT_BUTTON: 'createProjectButton',
  PROJECT_CREATE_BUTTON: 'projectCreateButton',
  NEW_PROJECT_LABEL: 'newProjectLabel',
  PROJECT_NAME_INPUT: 'projectNameInput'
} as const;
